export default __webpack_public_path__ + "static/media/perfshiju.e1415ccc.png";